<template>
    <div class="container">
        <iframe :src="src" style="width:100%; height: 1024px;"  frameborder="0" scrolling="no" ></iframe>
    </div>
</template>

<script>
const mainSettings = window.__MICRO_ROOT__ ?? {}
export default {
  data () {
    return {
      src: `https://irr.hnair.com/mobile/changeTicket/pc/index#/?cc=${mainSettings.airline}`
    }
  }
}
</script>
